import { computed, ref } from 'vue'
import { defineStore } from 'pinia'

export const useUiStatusStore = defineStore('uiStatus', () => {
  const savingSources = ref<Record<string, boolean>>({})
  const isSaving = computed(() => Object.values(savingSources.value).some(Boolean))

  function setSaving(source: string, saving: boolean) {
    if (saving) {
      savingSources.value = { ...savingSources.value, [source]: true }
      return
    }
    const next = { ...savingSources.value }
    delete next[source]
    savingSources.value = next
  }

  return { isSaving, setSaving }
})
